<template lang="html">
    <div class="view-selection">
        <PageTitle text="Ma sélection"></PageTitle>

        <div class="layout-width padding" v-if="userSite">

            <div
                style="margin-bottom:20px; padding: 20px 0;">
                <!-- <el-popover
                    v-if="!selectedMotorsValid"
                    width="250"
                    trigger="hover"
                    content="Certains moteurs sélectionnés nécessitent des informations complémentaires. Cliquez sur le bouton 'à renseigner' dans la colonne 'Plaque moteur'.">
                    <el-button
                        slot="reference"
                        type="primary">
                        Valider ma sélection
                    </el-button>
                </el-popover> -->
                <el-button

                    :disabled="noAudit"
                    :loading="loadingAudit"
                    type="primary"
                    @click="validateAudit">
                    Valider ma sélection
                </el-button>

                <el-button
                    :disabled="noAudit"
                    style="float:right"
                    icon="el-icon-circle-check"
                    type="success"
                    @click="selectSuggestedMotors">
                    Sélectionner les moteurs recommandés
                </el-button>
            </div>

            <el-alert
                v-if="noAudit"
                title="Aucun audit n'a été créé pour votre site, veuillez faire une demande à votre contact commercial"
                type="warning"
                show-icon
                style="margin-bottom: 15px;"
            >
            </el-alert>
            <div style="margin-bottom: 20px; color: green">* Les moteurs ci-dessous sont triés par ordre décroissant en terme de potentiel d’audit (Moteur 1 = moteur le plus intéressant à instrumenter)</div>
            <div style="margin-bottom: 20px; color: red">* Les moteurs apparaissant en rouge ne sont pas compatibles avec un audit motorbox</div>
            <div
                class="shadow"
                style="margin-bottom:20px;">
                <el-table
                    v-loading="loading"
                    :data="motorsByScore"
                    select
                    style="width: 100%">
                    <el-table-column
                        label="Classement"
                        class="index-label"
                        type="index"
                        width="115"
                        >


                    </el-table-column>
                    <el-table-column
                        prop="name"
                        label="Nom">
                        <template slot-scope="scope">
                            <div v-if="scope.row.score > 0">{{ scope.row.name }}</div>
                            <div v-else style="color: red">{{ scope.row.name }} *</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="Sélectionné">
                        <template slot-scope="scope">
                            <el-switch
                                :value="selectedMotorsUids.includes(scope.row.uid)"
                                :disabled="noAudit || scope.row.score <= 0"
                                @change="change(scope.row)"
                            ></el-switch>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="Recommandé">
                        <template slot-scope="scope">
                            <el-button
                                v-if="suggestionsUids.includes(scope.row.uid)"
                                size="mini"
                                circle
                                icon="el-icon-check"
                                type="success">
                            </el-button>
                            <el-button
                                v-else
                                size="mini"
                                circle
                                icon="el-icon-close">
                            </el-button>
                        </template>
                    </el-table-column>

                    <!-- <el-table-column
                        align="center"
                        label="Plaque moteur">
                        <template
                            v-if="selectedMotorsUids.includes(scope.row.uid)"
                            slot-scope="scope">
                            <el-button
                                v-if="hasDetails(scope.row)"
                                size="mini"
                                round
                                icon="el-icon-check"
                                type="success"
                                @click="editMotorDetails(scope.$index, scope.row)">
                                enregistrée
                            </el-button>
                            <el-button
                                v-if="!hasDetails(scope.row)"
                                size="mini"
                                round
                                icon="el-icon-warning"
                                type="primary"
                                @click="editMotorDetails(scope.$index, scope.row)">
                                à renseigner
                            </el-button>
                        </template>
                    </el-table-column> -->
                </el-table>
            </div>

        </div>

    </div>
</template>

<script>
import PageTitle from '@/components/partials/ui/PageTitle';
import { mapGetters } from 'vuex';
import { cloneDeep } from 'lodash';
export default {
    name: 'Selection',
    components: {
        PageTitle
    },
    data () {
        return {
            loadingAudit: false,
            loading: false,
            selectedMotors: [],
        };
    },
    computed: {
        ...mapGetters([
            'currentUser',
            'motor',
            'currentSite',
            'motorByUid',
            'auditByUid',
            'siteRelatedMotors',
            'auditSelectedMotorsUids'
        ]),
        currentAudit() {
            let audit = this.auditByUid(this.$route.params.auditUid)
            if (audit) {
                return audit
            }
            this.$router.push({name: 'Home'})
        },
        userSite () {
            if (this.currentSite){
                return this.currentSite
            }
            this.$router.push({name: 'Home'})
        },
        selectedMotorsUids() {
            return this.selectedMotors.map(m => m.uid)
        },
        noAudit (){
            return this.currentAudit ? false : true
        },
        selectedMotorsValid () {
            const validateSelection = this.selectedMotors.map(m => this.hasDetails(m));
            // eslint-disable-next-line
            return validateSelection.includes(false) ? false : true;
        },
        motorsByScore () {
            const sorted = cloneDeep(this.siteRelatedMotors);
            return sorted.sort((a, b) => b.score - a.score);
        },
        suggestions () {
            return this.motorsByScore.filter(m => m.score > 0).slice(0, this.currentAudit.motorbox_count);
        },
        suggestionsUids () {
            return this.suggestions.map(m => m.uid);
        }
    },
    mounted () {
        this.selectedMotors = this.siteRelatedMotors.filter(m => this.auditSelectedMotorsUids(this.currentAudit).includes(m.uid))
    },
    methods: {
        // check if all infos are filled in
        hasDetails (row) {
            let hasDetails = true;
            const detailKeys = [
                'detail_pn',
                'detail_un',
                'detail_in',
                'detail_cosphi',
                'detail_speed',
                'detail_regulation_uid'
            ];
            for (let k of detailKeys) {
                if (!row[k]) {
                    hasDetails = false;
                    break;
                }
            }
            return hasDetails;
        },
        // redirect to Plaque Moteur form
        // editMotorDetails (i, row) {
        //     this.$router.push({ name: 'MotorDetails', params: { motorUid: row.uid } });
        // },
        // check if audit.motorbox_count limit is reached
        change (item) {
            let index = this.selectedMotorsUids.indexOf(item.uid);
            let selected = index > -1 ? true : false;
            if (selected) {
                this.selectedMotors.splice(index, 1);
            }
            else if (this.selectedMotors.length < this.currentAudit.motorbox_count) {
                this.selectedMotors.push(item)
            } else {
                this.$notify({
                    title: 'Limite atteinte',
                    message: 'Votre souscription permet la sélection de ' + this.currentAudit.motorbox_count + ' Motorbox. Désélectionnez des moteurs ou contactez votre conseiller pour étendre votre souscription.',
                    type: 'error',
                    duration: 7000
                });
            }
        },
        // save (un)selected motor
        save (item) {
            delete item.measures_file;
            this.loading = true;
            this.$store.dispatch('patchItem', {
                item,
                model: 'motor',
                url: 'motor/'
            // eslint-disable-next-line
            }).then(res => {
                this.loading = false;
                // this.$notify({
                //   title: action,
                //   message: 'Moteur ' + action.toLowerCase() + ' avec succès',
                //   type: 'success'
                // })
            }).catch(err => {
                // eslint-disable-next-line
                console.error(err);
                this.loading = false;
                this.$notify({
                    title: 'Erreur',
                    message: err.message,
                    type: 'error'
                });
            });
        },
        // select all suggested motors
        selectSuggestedMotors () {
            this.selectedMotors = this.suggestions
            // this.loading = true;
            // const deselectAllNotSuggested = this.selectedMotors
            //     .filter(m => !this.suggestionsUids.includes(m.uid))
            //     .map(m => this.promiseSetMotor(m, false));
            // const selectAllNotSelected = this.suggestions
            //     .filter(m => !this.auditSelectedMotorsUids(this.currentAudit).includes(m.uid))
            //     .map(m => this.promiseSetMotor(m, true));
            // Promise.all(deselectAllNotSuggested).then(() => {
            //     Promise.all(selectAllNotSelected).then(() => {
            //         this.loading = false;
            //     });
            // });
        },
        // promise, child of selectSuggestedMotors()
        // promiseSetMotor (item, val) {
        //     item = cloneDeep(item);
        //     item.selected = val;
        //     delete item.measures_file;
        //     return new Promise((resolve, reject) => {
        //         this.$store.dispatch('patchItem', {
        //             item,
        //             model: 'motor',
        //             url: 'motor/'
        //         // eslint-disable-next-line
        //         }).then(res => {
        //             resolve();
        //         }).catch(err => {
        //             // eslint-disable-next-line
        //             console.error(err);
        //             reject(err);
        //             this.$notify({
        //                 title: 'Erreur',
        //                 message: err.message,
        //                 type: 'error'
        //             });
        //         });
        //     });
        // },
        validateAudit () {
            if (this.selectedMotors.length < this.currentAudit.motorbox_count) {
                this.$confirm('Votre souscription vous permet de commander ' + this.currentAudit.motorbox_count + ' Motorbox et vous n\'en avez sélectionné que ' + this.selectedMotors.length, 'Attention', {
                    confirmButtonText: 'Continuer',
                    cancelButtonText: 'Annuler',
                    type: 'warning'
                }).then(() => {
                    this.saveAudit();
                }).catch(() => {
                    // this.$message({
                    //   type: 'info',
                    //   message: 'Validation de l\'audit annulée'
                    // })
                });
            } else {
                this.saveAudit();
            }
        },
        saveAudit () {
            let data = {};
            data[new Date()] = JSON.stringify(this.selectedMotors.map((motor) => motor.uid));
            this.loadingAudit = true;
            const item = Object.assign(this.currentAudit, { data: data });
            this.$store.dispatch('patchItem', {
                item,
                model: 'audit',
                url: 'audit/'
            // eslint-disable-next-line
            }).then(res => {
                this.loadingAudit = false;
                this.$router.push('/');
                this.$notify({
                    title: 'Audit enregistré',
                    message: 'Votre commande de Motorbox a bien été enregistrée. Vous pouvez suivre l\'avancée de votre audit dans la rubrique "Suivi de mon audit".',
                    type: 'success',
                    duration: 7000
                });
            }).catch(err => {
                this.loadingAudit = false;
                // eslint-disable-next-line
                console.error(err);
                this.$notify({
                    title: 'Erreur',
                    message: err.message,
                    type: 'error'
                });
            });
        }
    }
};
</script>

<style lang="scss">
.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: rgba(white, 0) !important;
}

</style>



// WEBPACK FOOTER //
// src/components/page/Selection/index.vue